export default __webpack_public_path__ + "static/media/GUADALUPE RODRIGUEZ.ef0d4bdc.jpeg";